$(document).ready(function () {
    $(".doctor-slider").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
    });
});

document.addEventListener("DOMContentLoaded", function() {
    const thumbnails = document.querySelectorAll('.thumbnails img, .thumbnails video, .thumbnails .video-wrapper');
    const previewDiv = document.querySelector('.preview');

    thumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', function() {
            previewDiv.innerHTML = '';

            if (this.tagName === 'IMG') {
                const img = document.createElement('img');
                img.src = this.src;
                img.alt = this.alt;
                previewDiv.appendChild(img);
            } else if (this.tagName === 'VIDEO') {
                const video = document.createElement('video');
                video.controls = true;
                const source = document.createElement('source');
                source.src = this.querySelector('source').src;
                source.type = 'video/mp4';
                video.appendChild(source);
                previewDiv.appendChild(video);
            } else if (this.classList.contains('video-wrapper')) {
                const iframe = document.createElement('iframe');
                iframe.width = 560;
                iframe.height = 315;
                iframe.src = this.querySelector('iframe').src;
                iframe.frameborder = 0;
                iframe.allowfullscreen = true;
                previewDiv.appendChild(iframe);
            }
        });
    });
});